export default class SelectOptionObject {
  constructor(label, value) {
    this.label = label;
    this.value = value;
  }
}
